import React, { useRef, useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Button
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../Store/mainSlice';
import httpClient from '../../_util/api';
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar';

const ChangePassword = () => {
  const snackbar_Ref = useRef();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showPasswords, setShowPasswords] = useState({
    old: false,
    new: false,
    confirm: false
  });

  const handleChange = (value, field) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async () => {
    const { oldPassword, newPassword, confirmPassword } = formData;

    if (!oldPassword || !newPassword || !confirmPassword) {
      snackbar_Ref.current.showMessage('error', 'Please fill all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      snackbar_Ref.current.showMessage('error', 'Passwords do not match.');
      return;
    }

    dispatch(showLoader());
    try {
      const res = await httpClient.post('/user/changePassword', formData);
      if (res.status === 200) {
        snackbar_Ref.current.showMessage('success', res.data.message);
        setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
      }
    } catch (err) {
      snackbar_Ref.current.showMessage('error', err?.response?.data?.message || 'Error updating password');
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <CustomizedSnackbars ref={snackbar_Ref} />
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Change Password
        </Typography>

        <Stack spacing={2}>
          <TextField
            label="Old Password"
            type={showPasswords.old ? 'text' : 'password'}
            value={formData.oldPassword}
            onChange={(e) => handleChange(e.target.value, 'oldPassword')}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => togglePasswordVisibility('old')} edge="end">
                    {showPasswords.old ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="New Password"
            type={showPasswords.new ? 'text' : 'password'}
            value={formData.newPassword}
            onChange={(e) => handleChange(e.target.value, 'newPassword')}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => togglePasswordVisibility('new')} edge="end">
                    {showPasswords.new ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Confirm Password"
            type={showPasswords.confirm ? 'text' : 'password'}
            value={formData.confirmPassword}
            onChange={(e) => handleChange(e.target.value, 'confirmPassword')}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => togglePasswordVisibility('confirm')} edge="end">
                    {showPasswords.confirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ bgcolor: 'green', ':hover': { bgcolor: 'darkgreen' } }}
          >
            Update Password
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ChangePassword;
